<template>
  <div class="set-content-box">
    <div class="set-title">{{ title }}</div>
    <div class="avatar-content" v-if="mediaType === 1">
      <div class="set-avatar">
        <img
          :src="url ? url : require('../../../assets/img/noimg.png')"
          alt="avatar"
        />
      </div>
      <div class="set-avatar-btn">
        <div class="set-btn-wrap" v-if="isEdit">
          <material-select
            :type="mediaType"
            @selected="handleSelectedLandmark"
          >
            <template slot="body">
              <a-button type="primary">{{ btnTitle }}</a-button>
            </template>
          </material-select>
          <a-button type="danger" class="set-delete-btn" @click="handleDelete"
            >{{$t('actionTitles.delete')}}</a-button
          >
        </div>
        <div class="tips">{{$t('descriptions.recommendSize')}}：{{ size }}</div>
      </div>
    </div>
    <div class="avatar-content" v-if="mediaType === 2">
      <div class="set-audio">
        <audio preload="none" controls="controls" alt="example" :src="url"></audio>
      </div>
      <div class="set-btn-wrap" v-if="isEdit">
        <material-select
          :type="mediaType"
          @selected="handleSelectedLandmark"
        >
          <template slot="body">
            <a-button type="primary">{{ btnTitle }}</a-button>
          </template>
        </material-select>
        <a-button style="margin-top: 10px" type="danger" class="set-delete-btn" @click="handleDelete"
          >{{$t('actionTitles.delete')}}</a-button
        >
      </div>
    </div>
    <div class="contents" v-if="mediaType === -1">
      <a-textarea
        v-model="textValue"
        @change="handleSelectedLandmark(textValue)"
        :auto-size="{ minRows: 3, maxRows: 5 }"
        :disabled="!isEdit"
      ></a-textarea>
    </div>
    <div class="contents" v-if="mediaType === -2">
      <a-input v-model="textValue" :disabled="!isEdit" @change="handleSelectedLandmark(textValue)"/>
    </div>
  </div>
</template>

<script>
import MaterialSelect from "@/components/MaterialSelect";

export default {
  components: { MaterialSelect },
  props: {
    url: {
      type: String,
    },
    title: {
      default() {
        return this.$t("edit.title");
      },
      style: String,
    },
    btnTitle: {
      default() {
        return this.$t('message.uploadBtn')
      },
      type: String,
    },
    mediaType: {
      type: Number,
      default: 1,
    },
    inputValue: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "",
    },
  },
  watch: {
    inputValue(newValue) {
      this.textValue = newValue;
    },
  },
  data() {
    return {
      textValue: this.inputValue,
    };
  },
  methods: {
    handleSelectedLandmark(value) {
      this.$emit("changeMedia", value);
    },
    handleDelete() {
      this.$emit("deleteMedia");
    },
  },
};
</script>

<style lang="less" scoped>
.set-content-box {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.05);
}
.set-content-box:last-child {
  border-bottom: 0;
  box-shadow: none;
}
.set-title {
  padding: 10px 0;
}
.avatar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .set-avatar {
    width: 100px;
    height: 100px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.3);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-width: 100px;
      max-height: 100px;
    }
  }

  .set-avatar-btn {
    text-align: right;
    .tips {
      font-size: 12px;
      margin-top: 5px;
      color: rgba(255, 255, 255, 0.7);
    }

    .set-btn-wrap {
      display: flex;
      flex-direction: row;

      .set-delete-btn {
        margin-left: 10px;
      }
    }
  }
  .set-audio audio {
    width: 200px;
  }
}
</style>
